export const FETCHING_STATUS = "FETCHING_STATUS";

export const SET_IS_AUTHENTICATION = "SET_IS_AUTHENTICATION";
export const SET_AUTH_STATE = "SET_AUTH_STATE";

export const SET_USER_ID = "SET_USER_ID";
export const SET_USER_TYPE = "SET_USER_TYPE";
